module.exports = __webpack_public_path__ + "img/the_law_society_of_hong_kong.ab9a66c4.png";